import * as React from "react";

const ErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg id="error" fill="none" viewBox="0 0 130 132" {...props}>
    <g clipPath="url(#clip0)">
      <path
        d="M118.63 100.793C116.92 103.359 115.016 105.816 112.92 108.138C109.08 112.4 104.602 116.216 99.5221 119.437C69.4584 138.503 29.6283 129.586 10.5628 99.5221C-1.1646 81.0266 -2.30442 58.8389 5.55399 40.0602"
        stroke="#0F414C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M128.931 56.6301C129.324 59.6389 129.501 62.6619 129.466 65.6743"
        stroke="#0F414C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M63.7061 0.541589C85.4724 0.12389 106.927 10.7469 119.437 30.4779C122.68 35.5894 125.111 40.9805 126.768 46.5062"
        stroke="#0F414C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.5593 18.2903C23.5505 15.4513 26.8602 12.8566 30.4779 10.5628C35.7522 7.21771 41.3239 4.73629 47.0337 3.07611"
        stroke="#0F414C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M64.8885 121.674C96.4518 121.674 122.039 96.0872 122.039 64.5239C122.039 32.9606 96.4518 7.37344 64.8885 7.37344C33.3252 7.37344 7.73804 32.9606 7.73804 64.5239C7.73804 96.0872 33.3252 121.674 64.8885 121.674Z"
        fill="#EC7F91"
      />
      <path
        d="M111.324 44.4743C112.308 46.6903 113.136 48.9876 113.795 51.3558C115.006 55.6991 115.653 60.2761 115.653 65.0018C115.653 92.977 92.9737 115.657 64.9984 115.657C47.7878 115.657 32.5807 107.073 23.4268 93.954"
        stroke="white"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M86.3506 19.0513C88.5134 20.0566 90.5913 21.2141 92.5771 22.5026"
        stroke="white"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M21.678 38.7327C30.5629 24.1133 46.6408 14.3469 64.9983 14.3469C69.7523 14.3469 74.3576 15.0018 78.7222 16.2265"
        stroke="white"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.2991 74.8354C14.6726 71.6531 14.3469 68.3681 14.3469 65.0018C14.3469 60.0956 15.0443 55.3522 16.3469 50.8637"
        stroke="white"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M65.2674 103.841C86.6745 103.841 104.028 86.4868 104.028 65.0796C104.028 43.6725 86.6745 26.3186 65.2674 26.3186C43.8603 26.3186 26.5063 43.6725 26.5063 65.0796C26.5063 86.4868 43.8603 103.841 65.2674 103.841Z"
        fill="white"
        stroke="#0F414C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        opacity="0.2"
        d="M65.2674 103.841C86.6745 103.841 104.028 86.4868 104.028 65.0796C104.028 43.6725 86.6745 26.3186 65.2674 26.3186C43.8603 26.3186 26.5063 43.6725 26.5063 65.0796C26.5063 86.4868 43.8603 103.841 65.2674 103.841Z"
        fill="#0F414C"
      />
      <path
        d="M65.2674 97.469C86.6745 97.469 104.028 80.1151 104.028 58.708C104.028 37.3008 86.6745 19.9469 65.2674 19.9469C43.8603 19.9469 26.5063 37.3008 26.5063 58.708C26.5063 80.1151 43.8603 97.469 65.2674 97.469Z"
        fill="white"
        stroke="#0F414C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        opacity="0.2"
        d="M32.1665 58.708C32.1665 40.4248 46.9877 25.6035 65.2709 25.6035C83.5541 25.6035 98.3754 40.4248 98.3754 58.708"
        stroke="#0F414C"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        opacity="0.2"
        d="M88.1345 82.6442C82.1912 88.3221 74.1381 91.8088 65.2708 91.8088C57.3629 91.8088 50.1027 89.0372 44.4106 84.4106"
        stroke="#0F414C"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M54.4321 36.5841C57.0658 34.8885 60.3047 34.0389 64.1454 34.0389C69.1932 34.0389 73.3843 35.246 76.7259 37.6566C80.064 40.0673 81.7348 43.6425 81.7348 48.3752C81.7348 51.2779 81.0091 53.7239 79.5613 55.7133C78.7153 56.9204 77.0905 58.4602 74.6834 60.3363L72.3118 62.177C71.0197 63.1823 70.1631 64.354 69.7383 65.6956C69.6923 65.8372 69.6534 65.9929 69.6144 66.1593C69.1578 68.1841 67.402 69.6496 65.3277 69.6496H65.0127C62.3188 69.6496 60.2374 67.2566 60.6304 64.5912C60.8038 63.4195 61.0233 62.4956 61.2923 61.8266C61.8728 60.3858 63.3631 58.7292 65.7666 56.8531L68.2056 54.9451C69.0056 54.3434 69.6534 53.685 70.1419 52.9699C71.0339 51.7416 71.4764 50.3894 71.4764 48.9168C71.4764 47.2212 70.9808 45.6743 69.9896 44.2761C68.9985 42.8814 67.1861 42.1841 64.5596 42.1841C61.9755 42.1841 60.1419 43.0442 59.0622 44.7646C58.6056 45.4903 58.248 46.2266 57.9861 46.9735C57.3171 48.8779 55.4799 50.1239 53.4622 50.1239C50.1419 50.1239 47.802 46.8425 48.9029 43.7062C49.9896 40.6124 51.8339 38.2407 54.4321 36.5841ZM63.8693 74.2372H66.1312C68.2728 74.2372 70.0073 75.9717 70.0073 78.1133V80.0425C70.0073 82.1841 68.2728 83.9186 66.1312 83.9186H63.8693C61.7277 83.9186 59.9932 82.1841 59.9932 80.0425V78.1133C59.9932 75.9752 61.7277 74.2372 63.8693 74.2372Z"
        fill="#E02947"
        stroke="#0F414C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="130" height="130" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ErrorIcon;
